import { SHIFTTYPE } from "../actions/types";

const initialState = {
  createShiftType: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  getShiftTypes: {
    shiftTypes: {},
    isFetching: false,
    errorMessage: null,
  },
  getShiftType: {
    shiftType: {},
    isFetching: false,
    errorMessage: null,
  },
  updateShiftType: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  deleteShiftType: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region SHIFTTYPE.CREATE

    case SHIFTTYPE.SHIFTTYPE_CREATE_REQUEST:
      return {
        ...state,
        createShiftType: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_CREATE_SUCCESS:
      return {
        ...state,
        createShiftType: {
          successMessage: "Dienstsoort toevoegen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_CREATE_FAIL:
      return {
        ...state,
        createShiftType: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFTTYPE.GET_SHIFTTYPES

    case SHIFTTYPE.SHIFTTYPE_GET_SHIFTTYPES_REQUEST:
      return {
        ...state,
        getShiftTypes: {
          shiftTypes: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_GET_SHIFTTYPES_SUCCESS:
      return {
        ...state,
        getShiftTypes: {
          shiftTypes: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_GET_SHIFTTYPES_FAIL:
      return {
        ...state,
        getShiftTypes: {
          shiftTypes: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region SHIFTTYPE.GET

    case SHIFTTYPE.SHIFTTYPE_GET_REQUEST:
      return {
        ...state,
        getShiftType: {
          shiftType: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_GET_SUCCESS:
      return {
        ...state,
        getShiftType: {
          shiftType: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_GET_FAIL:
      return {
        ...state,
        getShiftType: {
          shiftType: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region SHIFTTYPE_UPDATE

    case SHIFTTYPE.SHIFTTYPE_UPDATE_REQUEST:
      return {
        ...state,
        updateShiftType: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_UPDATE_SUCCESS:
      return {
        ...state,
        updateShiftType: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_UPDATE_FAIL:
      return {
        ...state,
        updateShiftType: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFTTYPE_DELETE

    case SHIFTTYPE.SHIFTTYPE_DELETE_REQUEST:
      return {
        ...state,
        deleteShiftType: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_DELETE_SUCCESS:
      return {
        ...state,
        deleteShiftType: {
          successMessage: "Dienstsoort verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFTTYPE.SHIFTTYPE_DELETE_FAIL:
      return {
        ...state,
        deleteShiftType: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shiftTypeReducer.js